import { enableProdMode, StaticProvider } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { enableAkitaProdMode, persistState } from "@datorama/akita";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { hmrBootstrap } from "./hmr";



const providers: StaticProvider[] = [];

if (environment.production) {
  enableProdMode();
  enableAkitaProdMode();
} else {
  // Only persist in local dev
  providers.push({ provide: "persistStorage", useValue: persistState() });
}

const bootstrap = () => platformBrowserDynamic(providers).bootstrapModule(AppModule);

if (environment.hmr) {
  if (module["hot"]) {
    hmrBootstrap(module, bootstrap);
  } else {
    console.error("HMR is not enabled for webpack-dev-server!");
    console.log("Are you using the --hmr flag for ng serve?");
  }
} else {
  bootstrap().catch(err => console.error(err));
}
